export default "__VITE_ASSET___y$DSC3Z__"